import React from "react";
import InfoSection from "../components/InfoSection";
import { motion } from "framer-motion";

function Information() {
  return (
    <div className="infoContainer">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <InfoSection />
      </motion.div>
    </div>
  );
}

export default Information;
